import React from 'react';

const socialContent = [
  {
    icon: 'fa-twitter',
    link: 'https://twitter.com/smarnatai',
  },
  {
    icon: 'fa-instagram',
    link: 'https://www.instagram.com/smarnat.ai/',
  },
];

const ContactAddress = () => {
  return (
    <div className="row justify-content-center">
      {/*      <div className="col-lg-4 col-sm-6 d-lg-flex">
        <div className="address-info">
          <div className="icon d-flex align-items-end">
            <img src="images/icon/44.svg" alt="icon" />
          </div>
          <div className="title">Location</div>
          <p className="font-rubik">
            Melbourne, R. Market <br /> 1201 VIC
          </p>
        </div>{' '}
      </div> */}

      <div className="col-lg-4 col-sm-6 d-lg-flex">
        <div className="address-info">
          <div className="icon d-flex align-items-end">
            <img src="images/icon/45.svg" alt="icon" />
          </div>
          <div className="title">Contact</div>
          <p className="font-rubik">
            smarnatapp@gmail.com <br />
          </p>
        </div>{' '}
        {/* /.address-info  */}
      </div>
      {/* End .col */}

      <div className="col-lg-4 col-sm-6 d-lg-flex">
        <div className="address-info">
          <div className="icon d-flex align-items-end">
            <img src="images/icon/46.svg" alt="icon" />
          </div>
          <div className="title">Social Media</div>
          <p className="font-rubik">Find on social media</p>
          <ul className="d-flex justify-content-center">
            {socialContent.map((val, i) => (
              <li key={i}>
                <a href={val.link} target="_blank" rel="noreferrer">
                  <i className={`fa ${val.icon}`}></i>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {/* End .col */}
    </div>
  );
};

export default ContactAddress;
